<template>
  <span class="sdv-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="100%"
      height="100%"
    >
      <path :d="svg" />
    </svg>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi'

export default defineComponent({
  name: 'SdvBtn',
  props: {
    svg: {
      type: String,
      required: false,
      default: undefined
    },
    label: {
      type: String,
      required: false,
      default: undefined
    }
  },
  setup () {
    return {}
  }
})
</script>

<style lang="scss" src="./SdvIcon.scss" />
